<template>
  <div class="app">
    <div v-if="isPress">
      <press-list :data="filteredPressData"></press-list>
    </div>

    <div v-else-if="isEvents">
      <events :data="filteredEventsData"></events>
    </div>
  </div>
</template>

<script>
import Events from "./components/Events/Events.vue";
import PressList from "./components/Press/PressList.vue";

export default {
  name: "App",
  components: {
    Events,
    PressList,
  },
  props: {
    mediaType: {
      type: String,
      required: true,
    },
    // selectedProject: {
    //   type: String,
    //   required: true,
    // },
    country: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      data: [],
      eventsAPI:
        "https://opensheet.elk.sh/1sC5Q9QZrhvmTZgpes07Nfc8CFVXjirnfeBtkkSqtyCU/Data",
      pressAPI:
        "https://opensheet.elk.sh/14bxdhZ6AlpA4S4Fcgg232yDrk10UKP1T0VLpEuWcRx0/Data",
    };
  },
  computed: {
    isPress() {
      return this.mediaType == "press";
    },
    isEvents() {
      return this.mediaType == "events";
    },
    filteredPressData() {
      // if (this.selectedProject != "all" && this.country != "all") {
      //   return this.sortedData.filter(
      //     (item) =>
      //       (item.Reference1 == this.selectedProject ||
      //         item.Reference2 == this.selectedProject) &&
      //       item.AW_or_and_AWCH == this.country
      //   );
      // }
      // if (this.selectedProject != "all") {
      //   return this.sortedData.filter(
      //     (item) =>
      //       item.Reference1 == this.selectedProject ||
      //       item.Reference2 == this.selectedProject
      //   );
      // }
      if (this.country != "all") {
        return this.sortedData.filter(
          (item) =>item.AW_or_and_AWCH == this.country
        );
      } else {
        return this.sortedData;
      }
    },
    filteredEventsData() {
      if (this.country != "all") {
        return this.sortedData.filter(
          (item) => item.Invitee1_AW_AWCH == this.country
        );
      } else {
        return this.sortedData;
      }
    },
    sortedData() {
      var data = [...new Set(this.cleanedData)];
      return data.sort((a, b) => b.Date - a.Date);
    },
    cleanedData() {
      return this.data.map((item) => {
        if (this.mediaType == "events") {
          return {
            ...item,
            Date: new Date(item.Start_date),
            Time: item.Start_Time,
            City: {
              name_de: item.City_de,
              name_en: item.City_en,
              name_fr: item.City_fr,
              name_it: item.City_it
            },
          };
        }
        if (this.mediaType == "press") {
          return { ...item, Date: new Date(item.Date) };
        }
      });
    },
  },
  methods: {
    fetchData(API) {
      fetch(API)
        .then((response) => response.json())
        .then((data) => (this.data = data));
    },
  },
  mounted() {
    if (this.mediaType == "events") {
      this.fetchData(this.eventsAPI);
    }
    if (this.mediaType == "press") {
      this.fetchData(this.pressAPI);
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  text-align: left !important;
  line-height: 150%;
  color: #2c3e50 !important;
  margin-top: 60px !important;
  margin-bottom: 60px !important;
  max-width: 50rem;
  margin: auto;
}

:root {
  --AWBlue: #428bfa;
  --primaryOpaque: rgb(106, 90, 205, 0.2);
  --white: #ffffff;
}
</style>
